if (!customElements.get("recipient-form")) {
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.cartUpdateUnsubscriber = void 0;
      this.variantChangeUnsubscriber = void 0;
      this.cartErrorUnsubscriber = void 0;
      this.currentProductVariantId = this.dataset.productVariantId;
      this.getElements();
      this.addEventListener("change", this.onChange.bind(this));
      this.onChange();
    }
    getElements() {
      const sectionId = this.dataset.sectionId || "";
      const checkboxInput = this.querySelector(`#recipient-checkbox-${sectionId}`);
      checkboxInput.disabled = false;
      const hiddenControlField = this.querySelector(`#recipient-control-${sectionId}`);
      hiddenControlField.disabled = true;
      const offsetProperty = this.querySelector(`#recipient-timezone-offset-${sectionId}`);
      if (offsetProperty) {
        offsetProperty.value = (/* @__PURE__ */ new Date()).getTimezoneOffset().toString();
      }
      const errorMessageWrapper = this.querySelector(".sm-recipient-form__error");
      const errorMessage = errorMessageWrapper == null ? void 0 : errorMessageWrapper.querySelector(".sm-recipient-form__error-message");
      this.defaultErrorHeader = errorMessage == null ? void 0 : errorMessage.innerHTML;
      this.elements = {
        checkboxInput,
        hiddenControlField,
        recipientFieldsLiveRegion: this.querySelector(`#recipient-fields-live-region-${sectionId}`),
        emailInput: this.querySelector(`#recipient-email-${sectionId}`),
        nameInput: this.querySelector(`#recipient-name-${sectionId}`),
        messageInput: this.querySelector(`#recipient-message-${sectionId}`),
        sendonInput: this.querySelector(`#recipient-send-on-${sectionId}`),
        offsetProperty,
        errorMessageWrapper,
        errorMessage,
        errorMessageList: errorMessageWrapper == null ? void 0 : errorMessageWrapper.querySelector("ul")
      };
    }
    connectedCallback() {
      this.cartUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === "product-form" && event.productVariantId.toString() === this.currentProductVariantId) {
          this.resetRecipientForm();
        }
      });
      this.variantChangeUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId === this.dataset.sectionId) {
          this.currentProductVariantId = event.data.variant.id.toString();
        }
      });
      this.cartUpdateUnsubscriber = window.subscribe(window.PUB_SUB_EVENTS.cartError, (event) => {
        if (event.source === "product-form" && event.productVariantId.toString() === this.currentProductVariantId) {
          this.displayErrorMessage(event.message, event.errors);
        }
      });
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
      if (this.cartErrorUnsubscriber) {
        this.cartErrorUnsubscriber();
      }
    }
    onChange() {
      const checked = this.elements.checkboxInput.checked;
      if (checked) {
        this.enableInputFields();
        this.elements.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
      } else {
        this.clearInputFields();
        this.disableInputFields();
        this.clearErrorMessage();
        this.elements.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
      }
      const labelElement = this.elements.checkboxInput.parentNode;
      labelElement.dataset.checked = checked;
    }
    inputFields() {
      return [this.elements.emailInput, this.elements.nameInput, this.elements.messageInput, this.elements.sendonInput];
    }
    disableableFields() {
      return [...this.inputFields(), this.elements.offsetProperty];
    }
    clearInputFields() {
      this.inputFields().forEach((field) => field.value = "");
    }
    enableInputFields() {
      this.disableableFields().forEach((field) => field.disabled = false);
    }
    disableInputFields() {
      this.disableableFields().forEach((field) => field.disabled = true);
    }
    displayErrorMessage(title, body) {
      this.clearErrorMessage();
      this.elements.errorMessageWrapper.hidden = false;
      if (typeof body === "object") {
        this.elements.errorMessage.innerHTML = this.defaultErrorHeader;
        return Object.entries(body).forEach(([key, value]) => {
          const errorMessageId = `recipient-form-${key}-error-${this.dataset.sectionId}`;
          const fieldSelector = `#recipient-${key}-${this.dataset.sectionId}`;
          const message = `${value.join(", ")}`;
          const errorMessageElement = this.querySelector(`#${errorMessageId}`);
          const errorTextElement = errorMessageElement == null ? void 0 : errorMessageElement.querySelector(".sm-form__message-text");
          if (!errorTextElement)
            return;
          if (this.elements.errorMessageList) {
            this.elements.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
          }
          errorTextElement.innerText = `${message}.`;
          errorMessageElement.classList.remove("hidden");
          const inputElement = this[`${key}Input`];
          if (!inputElement)
            return;
          inputElement.setAttribute("aria-invalid", true);
          inputElement.setAttribute("aria-describedby", errorMessageId);
        });
      }
      this.elements.errorMessage.innerHTML = body;
    }
    createErrorListItem(target, message) {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.setAttribute("href", target);
      a.innerText = message;
      li.appendChild(a);
      return li;
    }
    clearErrorMessage() {
      this.elements.errorMessageWrapper.hidden = true;
      if (this.elements.errorMessageList)
        this.elements.errorMessageList.innerHTML = "";
      this.querySelectorAll(".sm-recipient-fields__error").forEach((field) => {
        field.classList.add("hidden");
        const textField = field.querySelector(".sm-form__message-text");
        if (textField)
          textField.innerText = "";
      });
      this.inputFields().forEach((inputElement) => {
        inputElement.setAttribute("aria-invalid", false);
        inputElement.removeAttribute("aria-describedby");
      });
    }
    resetRecipientForm() {
      if (this.elements.checkboxInput.checked) {
        this.elements.checkboxInput.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  customElements.define("recipient-form", RecipientForm);
}
